// Login data lives in localStorage so every tab of the app shares one session
// (sessionStorage is per tab, which forced a fresh login in each new tab).
export const AUTH_STORAGE_KEY = "authData";

export const getStoredAuth = (): string | null => {
  try {
    const value = localStorage.getItem(AUTH_STORAGE_KEY);
    if (value) return value;
    // One-time migration for tabs that logged in before the switch.
    const legacy = sessionStorage.getItem(AUTH_STORAGE_KEY);
    if (legacy) {
      localStorage.setItem(AUTH_STORAGE_KEY, legacy);
      sessionStorage.removeItem(AUTH_STORAGE_KEY);
    }
    return legacy;
  } catch {
    return null;
  }
};

export const setStoredAuth = (value: string) => {
  try {
    localStorage.setItem(AUTH_STORAGE_KEY, value);
  } catch {}
};

export const removeStoredAuth = () => {
  try {
    localStorage.removeItem(AUTH_STORAGE_KEY);
    sessionStorage.removeItem(AUTH_STORAGE_KEY);
  } catch {}
};
